import { useEffect } from 'react';
import { Container, Row, Col, Card, Modal, Button, Tab, Tabs, Table, Form } from 'react-bootstrap';
import Footer from './components/Footer';
import { useState } from "react";

export default function Programme() {
  useEffect(() => {
    const titles = document.querySelectorAll('.card-title');
    titles.forEach(el => {
      const angle = Math.floor(Math.random() * 360);
      el.style.background = `linear-gradient(${angle}deg, #33A749, #AB1E4A)`;
      
    });
  }, []);

  const [activeModal, setActiveModal] = useState(null);

  const handleClose = () => setActiveModal(null);
  const handleShow = (modalId) => setActiveModal(modalId);

  const programmeSun = [
    { time: '16:00 – 20:00', session: 'Registration', type: 'organize' },
    { time: '17:05 – 17:30', session: 'Opening session' },
    { time: '17:30 – 18:30', session: 'Plenary session' },
    { time: '18:30 – 19:00', session: 'Albertsson Award' },
    { time: '19:00 – 20:30', session: 'Welcome reception', type: 'special' },
  ];
  const programmeMon = [
  { time: '08:00 – 09:00', session: 'Registration', type: 'organize' },
  { time: '09:00 – 10:00', session: 'Plenary session' },
  { time: '10:00 – 10:20', session: 'Oral 1' },
  { time: '10:20 – 10:40', session: 'Oral 2' },
  { time: '10:40 – 10:50', session: 'Tosoh presentation' },
  { time: '10:50 – 11:20', session: 'Coffee Break', type: 'break' },
  { time: '11:20 – 11:50', session: 'Keynote' },
  { time: '11:50 – 12:10', session: 'Oral 3' },
  { time: '12:10 – 12:30', session: 'Oral 4' },
  { time: '12:30 – 12:40', session: 'Oral 5' },
  { time: '12:40 – 13:40', session: 'Lunch', type: 'break' },
  { time: '13:40 – 14:40', session: 'Poster session' },
  { time: '14:40 – 15:00', session: 'Oral 6' },
  { time: '15:00 – 15:20', session: 'Oral 7' },
  { time: '15:20 – 15:40', session: 'Oral 8' },
  { time: '15:40 – 16:00', session: 'Oral 9' },
  { time: '16:00 – 16:20', session: 'Oral 10' },
  { time: '16:20 – 16:45', session: 'Fire sessions' },
  { time: '17:00', session: 'Trip to Bled Island and Church', type: 'special' },
];

const programmeTue = [
  { time: '08:00 – 09:00', session: 'Registration', type: 'organize' },
  { time: '09:00 – 10:00', session: 'Plenary session' },
  { time: '10:00 – 10:20', session: 'Oral 1' },
  { time: '10:20 – 10:40', session: 'Oral 2' },
  { time: '10:40 – 11:00', session: 'Oral 3' },
  { time: '11:00 – 11:30', session: 'Coffee Break', type: 'break' },
  { time: '11:30 – 11:50', session: 'Oral 4' },
  { time: '11:50 – 12:10', session: 'Oral 5' },
  { time: '12:10 – 12:30', session: 'Oral 6' },
  { time: '12:30 – 12:50', session: 'Oral 7' },
  { time: '12:50 – 13:00', session: 'Fire session' },
  { time: '13:00 – 14:00', session: 'Lunch', type: 'break' },
  { time: '14:00 – 14:30', session: 'Poster session' },
  { time: '14:30 – 15:00', session: 'Keynote' },
  { time: '15:00 – 15:20', session: 'Oral 9' },
  { time: '15:20 – 15:40', session: 'Oral 10' },
  { time: '15:40 – 16:00', session: 'Oral 11' },
  { time: '16:00 – 16:30', session: 'Coffee Break', type: 'break' },
  { time: '16:20 – 16:40', session: 'Oral 12' },
  { time: '16:40 – 17:00', session: 'Oral 13' },
  { time: '17:00 – 17:20', session: 'Oral 14' },
  { time: '17:20 – 18:30', session: 'Round table' },
  { time: '20:00', session: 'Conference Dinner', type: 'special' },
];

const programmeWed = [
  { time: '08:00 – 09:00', session: 'Registration', type: 'organize' },
  { time: '09:00 – 14:00', session: 'SSbD Workshop organized by TOXBOX', type: 'special' },
  { time: '09:00 – 10:00', session: 'Plenary session (SSbD)' },
  { time: '10:00 – 10:20', session: 'Oral 1' },
  { time: '10:20 – 10:40', session: 'Oral 2' },
  { time: '10:40 – 11:00', session: 'Oral 3' },
  { time: '11:00 – 11:30', session: 'Coffee Break', type: 'break' },
  { time: '11:30 – 11:50', session: 'Oral 4' },
  { time: '11:50 – 12:10', session: 'Oral 5' },
  { time: '12:10 – 12:30', session: 'Oral 6' },
  { time: '12:30 – 12:50', session: 'Oral 7' },
  { time: '12:50 – 13:00', session: 'Fire session' },
  { time: '13:00 – 14:00', session: 'Lunch', type: 'break' },
  { time: '14:00 – 14:30', session: 'Poster session' },
  { time: '14:30 – 15:00', session: 'Keynote' },
  { time: '15:00 – 15:20', session: 'Oral 9' },
  { time: '15:20 – 15:40', session: 'Oral 10' },
  { time: '15:40 – 16:00', session: 'Oral 11' },
  { time: '16:00 – 16:30', session: 'Coffee Break', type: 'break' },
  { time: '16:20 – 16:40', session: 'Oral 12' },
  { time: '16:40 – 17:00', session: 'Oral 13' },
  { time: '17:00 – 17:20', session: 'Oral 14' },
  { time: '17:20 – 17:40', session: 'Oral 15' },
  { time: '17:40 – 18:30', session: 'Closing session', type: 'special' },
];

const [activeKey, setActiveKey] = useState('sunday');

  return (
    <>
    <section id="hero" className="hero hero-background  position-relative">
      <Container >
        <Row className="align-items-center">
            <Col md={8} lg={6} className=''>
              <h1 className="display-3 fw-bold text-white">Programme</h1>
            </Col>
          </Row>
      </Container>
    </section>
    
    <section id="programme">
      
      <Container >
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pt-5 pb-4'>
            <h2 className='h1 mb-4 purple-h'>Scientific Programme</h2>
            <p>The scientific programme brings together <highlight>a diverse range of topics at the forefront of bioprocessing and bioproduct development.</highlight> It reflects the latest advances in downstream processing, integration and optimization of processes, regulatory and sustainability frameworks, and the engineering of novel bioproducts. Participants will gain insight into state-of-the-art techniques, emerging research trends, and innovative approaches that are shaping the future of the field.</p>
          </Col>
        </Row>

        <Form.Select
          className="programme-mobile-select mb-3"
          value={activeKey}
          onChange={(e) => setActiveKey(e.target.value)}
        >
          <option value="sunday">Sunday, Sep 6<sup>th</sup></option>
          <option value="monday">Monday, Sep 7<sup>th</sup></option>
          <option value="tuesday">Tuesday, Sep 8<sup>th</sup></option>
          <option value="wednesday">Wednesday, Sep 9<sup>th</sup></option>
        </Form.Select>

        <Tabs activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
        id="programme-tabs"
        fill
        className="mb-3 programme-tabs">
          <Tab eventKey="sunday" title="Sunday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeSun.map((item, index) => (
                  <tr key={index} className={item.type ? `programme-${item.type}` : ''}>
                    <td>{item.time}</td>
                    <td>{item.session}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="monday" title="Monday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeMon.map((item, index) => (
                  <tr key={index} className={item.type ? `programme-${item.type}` : ''}>
                    <td>{item.time}</td>
                    <td>{item.session}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="tuesday" title="Tuesday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeTue.map((item, index) => (
                  <tr key={index} className={item.type ? `programme-${item.type}` : ''}>
                    <td>{item.time}</td>
                    <td>{item.session}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="wednesday" title="Wednesday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeWed.map((item, index) => (
                  <tr key={index} className={item.type ? `programme-${item.type}` : ''}>
                    <td>{item.time}</td>
                    <td>{item.session}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </Container>

    </section>

    <section id="speakers">
      <Container className='my-5'>
        <Row className="py-5">
          <Col lg={{ span: 8, offset: 2 }} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Invited speakers</h2>
          </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalA")}>
                <Card.Img variant="top" src="images/speaker-frampton.jpg" className='img-fluid'/>
                
                <Card.Body className='p-4'>
                  <h5>John P. Frampton</h5>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalB")}>
                <Card.Img variant="top" src="images/speaker-bullow.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Leif Bülow</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalC")}>
                <Card.Img variant="top" src="images/speaker-barros.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Raquel Aires-Barros</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalD")}>
                <Card.Img variant="top" src="images/speaker-sandak.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Anna Sandak</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalE")}>
                <Card.Img variant="top" src="images/speaker-jokic.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Stela Jokić</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalF")}>
                <Card.Img variant="top" src="images/speaker-oztop.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Mecit Öztop</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>
      </Container>
    </section>


    <section id="content">
      <Container >
        
        <Row className="py-5">
          <Col lg={{ span: 8, offset: 2 }} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Conference Topics</h2>
          </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 '>
                <Card.Title>Downstream Processing</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Techniques include aqueous two-phase systems, chromatography, membranes, ligands, precipitation, crystallization, flocculation, etc.	Incorporates molecular and thermodynamic aspects for enhanced separation of bioproducts</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Process Integration and Optimization</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Focus on continuous production, high-throughput screening, and automation. Leverages artificial intelligence, neural networks, and multiscale modeling to optimize conditions and efficiency.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Regulatory and Sustainability Considerations</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Addresses regulatory aspects and incorporates sustainability assessments such as life cycle analysis (LCA), social LCA, techno-economic analysis (TEA), and Safe and Sustainable by Design (SSbD) approaches.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Bioproducts Engineering for Bioprocessing Enhancement</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Innovation in value and supply chain creation. Protein engineering. Development of new products. Focus on hydrogels, soft matter applications, and in situ resource utilisation, with circular and green chemistry approaches.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Biomass processing</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Pre-treatment strategies. Enzymatic, microbial and catalytic processing. Conversion technologies. Waste valorisation.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
      </Container>

      
    </section>

     
      <Footer />



      <Modal show={activeModal !== null} onHide={handleClose} size="lg" scrollable centered>
        <Modal.Header closeButton className='px-4'>
          <Modal.Title >
            {activeModal === "modalA" && "John P. Frampton"}
            {activeModal === "modalB" && "Leif Bülow"}
            {activeModal === "modalC" && "Raquel Aires-Barros"}
            {activeModal === "modalD" && "Anna Sandak"}
            {activeModal === "modalE" && "Stela Jokić"}
            {activeModal === "modalF" && "Mecit Öztop"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          {activeModal === "modalA" && "John P. Frampton obtained his PhD from the State University of New York at Albany in 2009 before completing a postdoctoral fellowship at University of Michigan in 2014. From 2014 to 2024, he held the Tier II Canada Research Chair in Cell, Biomaterial and Matrix Interaction in the School of Biomedical Engineering at Dalhousie University. He leads an interdisciplinary team working at the intersection of materials science, cell biology and clinical research to design next-generation technologies for: (1) understanding fundamental biological processes; (2) understanding how diseases work and improving diagnosis; and (3) developing therapies using advanced natural and synthetic materials. The Frampton Lab is engaged in numerous collaborative projects across academic disciplines, e.g., with neurobiologists to develop materials for repairing spinal cord and peripheral nerve damage, with immunologists to examine the role of immune cells in asthma and other respiratory diseases using living tissue models grown in the lab, and with physicists and chemists to understand the fundamental properties of soft materials such as gels, fibers, and emulsions. The Frampton Lab is also engaged in several industry collaborations to develop new bio-inks for 3D bioprinting and materials for the repair of acute and chronic wounds. In addition to his academic work, Dr. Frampton is CSO of 3D BioFibR Inc., an advanced materials manufacturing company that spun off from his laboratory in 2020. "}
          {activeModal === "modalB" && "Leif Bülow obtained his academic training in several laboratories in Sweden, Netherlands, Switzerland, France and USA.  He has been the main supervisor of 35 completed PhDs, co-supervisor of 14 PhDs. LB has been visiting Professor in plant biotechnology, Jules Verne University, France and guest professor, Swedish Agricultural University. He was awarded the title Honory Doctor in Medical Technology at Mahidol University, Bangkok in 2006. He has held several managing roles in academia and industry including chairman of the Vinnova Excellence Center Center for Bioseparation, Director of  PlantLink (www.plantlink.se), National chairman for the HSV evaluation in Biotechnology, Environmental science and Chemical engineering, Global president of “Blood Substitutes and Oxygen Therapy”, an international organization including academia, industry and regular authorities (e.g. FDA) to promote knowledge and information about alternatives to regular blood. In 2016, he acted as Chairman of the Biotech evaluation of UTC, Compiegne, France, together with the High Council for the Evaluation of Research and Higher Education” (HCERES). Between 2018 and 2023, LB acted as Chairman of Department of Chemistry, Lund University. Since 2017, he serves as Managing Director of ScanOats (www.scanoats.se), an Industrial Research Center focusing on oats. "}
          {activeModal === "modalC" && "Raquel Aires-Barros graduated in Chemical Engineering at Instituto Superior Técnico (IST), where she also earned a Master’s in Biotechnology and a PhD in Chemical Engineering. She conducted research at the Massachusetts Institute of Technology (MIT) before joining IST, where she progressed to Full Professor in the Department of Bioengineering. She is also Senior Researcher at the Institute for Bioengineering and Biosciences (IBB), leading the Bioprocess Engineering group. She has held several senior academic leadership roles at IST, including President of the Pedagogical Council, Vice-President of the Scientific Council, and Vice-President of the School Board. Since 2022, she has served as Técnico Ombudsman. She previously coordinated the Master in Biological Engineering and contributed to the MIT-Portugal PhD Program. Her research focuses on developing high-performance separation processes for biopharmaceutical purification, especially antibody purification and microscale “Lab-on-a-Chip” systems. She has participated in multiple European projects, chairs the Downstream Processing Section of ESBES, and serves on scientific and organising committees of several international conferences. She is President of the Portuguese Society for Biotechnology and Editor of Separation and Purification Technology. She has supervised over 70 graduate theses and authored more than 200 publications."}
          {activeModal === "modalD" && "Anna Sandak is an associate professor at the University of Primorska, where she leads the Materials Group at the InnoRenew CoE Department. Her academic background bridges biology and wood science. Before moving to Slovenia, she worked in Italy at the National Research Council (CNR-IVALSA). In her 18-year scientific career, she has contributed to over 30 research projects, leading 12 of them, and supervising 4 MSCA postdoctoral researchers. In 2022, Dr Sandak was awarded the ERC consolidator grant for the project ARCHI-SKIN, which develops a living coatings system based on fungal biofilm. Her study on probiotic architecture continues within the REMEDY project, recently awarded under the European Innovation Council Pathfinder call, which she coordinates. She represents research and academia on the European Commission’s Technology Council for Advanced Materials and serves on the Management Board of the New European Bauhaus Academy Pioneer Hub, the steering committee of the EIC’s Engineered Living Materials portfolio, and the Research and Innovation working group of WoodPop. Her research focuses on the intersection of biotech and advanced materials, concentrating on exploiting renewable materials and engineered living systems to revolutionize the construction industry. By integrating biotechnology with traditional building practices, she aims to create resilient, eco-friendly structures that adapt and evolve with their environments, setting new standards for sustainability in the built environment."}
          {activeModal === "modalE" && "Born in Našice in 1982; enrolled in a Postgraduate University Study Program of Food Engineering in 2008, and in 2011 she received her PhD. Professional activity: a full professor at Faculty of Food technology Osijek at the Department of Process Engineering. From 2018 to 2021 she was a Vice-dean for Science an from 2021 to 2025 Vice-Dean for Marketing and Business Cooperation. Today she is a dean of the Faculty of gFood Technology. Research work: involved in realization of many scientific and professional projects. She was a project leader in ten projects mainly related to the extraction of bioactive compounds. She designed and constructed the first pilot supercritical CO2 extraction device in the Republic of Croatia. Supervised: 7 PhD theses. Bibliography: author/co-author of more than 200 articles in international peer-reviewed journals and 15 book chapters. Cumulative h-index = 52. Awards:  Croatian Women of Influence 2025 (science and technology); National Science Award for 2018 for promotion of the science (Republic Croatia); Award of the Croatian Academy of Engineering Rikard Podhorsky; National Science Award for 2016 in the field of Biotechnical science; Danubius Young Scientist Award 2015 for Croatia; Award of the Croatian Academy of Engineering for young scientist “Vera Johanides” in 2013, Annual Science Award for the year 2012 from Osijek-Baranja County, National Science Award for 2011 for young scientist Additionally: She achieved a good communication and professional skills during her several months stay at USA and in different European countries through mobility exchange programs. She has excellent cooperation with the industry where participated in the development of new products. She has promoted science and the profession many times through different media as well as through popular scientific and professional lectures at various events. She is a member of the Croatian Society of Chemical Engineering, European Hygienic Engineering and Design Group; TehnOS association. She is elected as the top 2% of scientist by Stanford University and Elsevier last four years. She is now Editor-in-Chief of Croatian Journal of Food Science and Technology"}
          {activeModal === "modalF" && "Prof. Dr. H. Mecit Öztop is a faculty member in the Department of Food Engineering at Middle East Technical University and currently serves as the Research Coordinator of the university. His research focuses on food processing, food structure–function relationships, alternative proteins, aerogels, rheology, MRI and NMR applications in food systems, and sustainable food technologies. He has coordinated and participated in numerous national and international projects funded by Horizon Europe, PRIMA, COST, and TÜBİTAK, including MSCA Doctoral Networks and Staff Exchange projects. Prof. Öztop has extensive experience in interdisciplinary research, innovation management, and international collaboration, particularly in the areas of sustainable food systems, valorisation of agro-industrial side streams, and advanced characterization techniques. He has supervised more than 50 graduate theses and leads an active research group at METU working on innovative food processing and material science applications. Alongside his academic activities, he contributes to research strategy, capacity building, and internationalization efforts at institutional and European levels."}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="bpp-pink" size="lg" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}
 